import apiSlice from "./api/api";

const BROADCAST = "/notifications/broadcast";
const BROADCAST_HISTORY = "/notifications/broadcast/history";
const BROADCAST_PREVIEW = "/notifications/broadcast/preview";

const notificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Send broadcast message
    sendBroadcast: builder.mutation({
      query: (data) => ({
        url: BROADCAST,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BroadcastHistory"],
    }),

    // Preview recipients count
    previewRecipients: builder.mutation({
      query: (filters) => ({
        url: BROADCAST_PREVIEW,
        method: "POST",
        body: filters,
      }),
    }),

    // Get broadcast history
    getBroadcastHistory: builder.query({
      query: (params) => ({
        url: BROADCAST_HISTORY,
        method: "GET",
        params: params,
      }),
      providesTags: ["BroadcastHistory"],
    }),

    // Get broadcast by ID
    getBroadcastById: builder.query({
      query: (id) => ({
        url: `${BROADCAST}/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSendBroadcastMutation,
  usePreviewRecipientsMutation,
  useGetBroadcastHistoryQuery,
  useGetBroadcastByIdQuery,
} = notificationApiSlice;
